import React from 'react';
import Main from './Main';
import ReportListContainer from '../containers/ReportListContainer';
import './Reports.css';

export default () => {
  return (
    <Main>
      <div className="reports-content">
        <section className="section reports">
          <h2 className="section-title">Reportes</h2>
          <div className="reports-grid">
            <ReportListContainer />
          </div>
        </section>
      </div>
    </Main>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports.js